module.exports = __webpack_public_path__ + "04-scaffalature-componibili.jpg?6160ee8b1950f798c52fe65941e1d812";


//////////////////
// WEBPACK FOOTER
// ./src/img/gioco2/04-scaffalature-componibili.jpg
// module id = 385
// module chunks = 0